import { ANIMATIONS_NAME_MAP, HORIZONTAL_DIRECTION } from './ContinuousScroll.constants';
export function getInnerContainerStyle(_ref) {
  var animationDuration = _ref.animationDuration,
    direction = _ref.direction;
  var animationName = ANIMATIONS_NAME_MAP[direction] || ANIMATIONS_NAME_MAP[HORIZONTAL_DIRECTION];
  return {
    animation: "".concat(animationName, " ").concat(animationDuration, "s linear infinite")
  };
}